//BASE URL
export const BASE_URL = 'https://aboodbus.co.tz/passenger/';
export const API_URL = 'https://aboodbus.co.tz/api/';
export const USER_URL = 'https://197-250-2-138.sslip.io/api/v1/passenger/';